/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppDocsRouteImport } from './routes/app-docs'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthViagensRouteImport } from './routes/_auth/viagens'
import { Route as AuthVeiculosRouteImport } from './routes/_auth/veiculos'
import { Route as AuthVeiculoTiposRouteImport } from './routes/_auth/veiculo-tipos'
import { Route as AuthVeiculoCategoriasRouteImport } from './routes/_auth/veiculo-categorias'
import { Route as AuthUsuariosRouteImport } from './routes/_auth/usuarios'
import { Route as AuthTesteViagensXlsxRouteImport } from './routes/_auth/teste-viagens-xlsx'
import { Route as AuthRelatoriosRouteImport } from './routes/_auth/relatorios'
import { Route as AuthRecalcularEventosRouteImport } from './routes/_auth/recalcular-eventos'
import { Route as AuthPerfilRouteImport } from './routes/_auth/perfil'
import { Route as AuthParametrosRouteImport } from './routes/_auth/parametros'
import { Route as AuthPainelRouteImport } from './routes/_auth/painel'
import { Route as AuthMotoristasRouteImport } from './routes/_auth/motoristas'
import { Route as AuthGruposEmpresariaisRouteImport } from './routes/_auth/grupos-empresariais'
import { Route as AuthFeatureFlagsRouteImport } from './routes/_auth/feature-flags'
import { Route as AuthEmpresasRouteImport } from './routes/_auth/empresas'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthBasesOperacionaisRouteImport } from './routes/_auth/bases-operacionais'
import { Route as AuthViagensIdRouteImport } from './routes/_auth/viagens.$id'

const AppDocsRoute = AppDocsRouteImport.update({
  id: '/app-docs',
  path: '/app-docs',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthViagensRoute = AuthViagensRouteImport.update({
  id: '/viagens',
  path: '/viagens',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVeiculosRoute = AuthVeiculosRouteImport.update({
  id: '/veiculos',
  path: '/veiculos',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVeiculoTiposRoute = AuthVeiculoTiposRouteImport.update({
  id: '/veiculo-tipos',
  path: '/veiculo-tipos',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVeiculoCategoriasRoute = AuthVeiculoCategoriasRouteImport.update({
  id: '/veiculo-categorias',
  path: '/veiculo-categorias',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsuariosRoute = AuthUsuariosRouteImport.update({
  id: '/usuarios',
  path: '/usuarios',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTesteViagensXlsxRoute = AuthTesteViagensXlsxRouteImport.update({
  id: '/teste-viagens-xlsx',
  path: '/teste-viagens-xlsx',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRelatoriosRoute = AuthRelatoriosRouteImport.update({
  id: '/relatorios',
  path: '/relatorios',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecalcularEventosRoute = AuthRecalcularEventosRouteImport.update({
  id: '/recalcular-eventos',
  path: '/recalcular-eventos',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerfilRoute = AuthPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AuthRoute,
} as any)
const AuthParametrosRoute = AuthParametrosRouteImport.update({
  id: '/parametros',
  path: '/parametros',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPainelRoute = AuthPainelRouteImport.update({
  id: '/painel',
  path: '/painel',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMotoristasRoute = AuthMotoristasRouteImport.update({
  id: '/motoristas',
  path: '/motoristas',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGruposEmpresariaisRoute = AuthGruposEmpresariaisRouteImport.update({
  id: '/grupos-empresariais',
  path: '/grupos-empresariais',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeatureFlagsRoute = AuthFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEmpresasRoute = AuthEmpresasRouteImport.update({
  id: '/empresas',
  path: '/empresas',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBasesOperacionaisRoute = AuthBasesOperacionaisRouteImport.update({
  id: '/bases-operacionais',
  path: '/bases-operacionais',
  getParentRoute: () => AuthRoute,
} as any)
const AuthViagensIdRoute = AuthViagensIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthViagensRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app-docs': typeof AppDocsRoute
  '/bases-operacionais': typeof AuthBasesOperacionaisRoute
  '/dashboard': typeof AuthDashboardRoute
  '/empresas': typeof AuthEmpresasRoute
  '/feature-flags': typeof AuthFeatureFlagsRoute
  '/grupos-empresariais': typeof AuthGruposEmpresariaisRoute
  '/motoristas': typeof AuthMotoristasRoute
  '/painel': typeof AuthPainelRoute
  '/parametros': typeof AuthParametrosRoute
  '/perfil': typeof AuthPerfilRoute
  '/recalcular-eventos': typeof AuthRecalcularEventosRoute
  '/relatorios': typeof AuthRelatoriosRoute
  '/teste-viagens-xlsx': typeof AuthTesteViagensXlsxRoute
  '/usuarios': typeof AuthUsuariosRoute
  '/veiculo-categorias': typeof AuthVeiculoCategoriasRoute
  '/veiculo-tipos': typeof AuthVeiculoTiposRoute
  '/veiculos': typeof AuthVeiculosRoute
  '/viagens': typeof AuthViagensRouteWithChildren
  '/viagens/$id': typeof AuthViagensIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app-docs': typeof AppDocsRoute
  '/bases-operacionais': typeof AuthBasesOperacionaisRoute
  '/dashboard': typeof AuthDashboardRoute
  '/empresas': typeof AuthEmpresasRoute
  '/feature-flags': typeof AuthFeatureFlagsRoute
  '/grupos-empresariais': typeof AuthGruposEmpresariaisRoute
  '/motoristas': typeof AuthMotoristasRoute
  '/painel': typeof AuthPainelRoute
  '/parametros': typeof AuthParametrosRoute
  '/perfil': typeof AuthPerfilRoute
  '/recalcular-eventos': typeof AuthRecalcularEventosRoute
  '/relatorios': typeof AuthRelatoriosRoute
  '/teste-viagens-xlsx': typeof AuthTesteViagensXlsxRoute
  '/usuarios': typeof AuthUsuariosRoute
  '/veiculo-categorias': typeof AuthVeiculoCategoriasRoute
  '/veiculo-tipos': typeof AuthVeiculoTiposRoute
  '/veiculos': typeof AuthVeiculosRoute
  '/viagens': typeof AuthViagensRouteWithChildren
  '/viagens/$id': typeof AuthViagensIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/app-docs': typeof AppDocsRoute
  '/_auth/bases-operacionais': typeof AuthBasesOperacionaisRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/empresas': typeof AuthEmpresasRoute
  '/_auth/feature-flags': typeof AuthFeatureFlagsRoute
  '/_auth/grupos-empresariais': typeof AuthGruposEmpresariaisRoute
  '/_auth/motoristas': typeof AuthMotoristasRoute
  '/_auth/painel': typeof AuthPainelRoute
  '/_auth/parametros': typeof AuthParametrosRoute
  '/_auth/perfil': typeof AuthPerfilRoute
  '/_auth/recalcular-eventos': typeof AuthRecalcularEventosRoute
  '/_auth/relatorios': typeof AuthRelatoriosRoute
  '/_auth/teste-viagens-xlsx': typeof AuthTesteViagensXlsxRoute
  '/_auth/usuarios': typeof AuthUsuariosRoute
  '/_auth/veiculo-categorias': typeof AuthVeiculoCategoriasRoute
  '/_auth/veiculo-tipos': typeof AuthVeiculoTiposRoute
  '/_auth/veiculos': typeof AuthVeiculosRoute
  '/_auth/viagens': typeof AuthViagensRouteWithChildren
  '/_auth/viagens/$id': typeof AuthViagensIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app-docs'
    | '/bases-operacionais'
    | '/dashboard'
    | '/empresas'
    | '/feature-flags'
    | '/grupos-empresariais'
    | '/motoristas'
    | '/painel'
    | '/parametros'
    | '/perfil'
    | '/recalcular-eventos'
    | '/relatorios'
    | '/teste-viagens-xlsx'
    | '/usuarios'
    | '/veiculo-categorias'
    | '/veiculo-tipos'
    | '/veiculos'
    | '/viagens'
    | '/viagens/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app-docs'
    | '/bases-operacionais'
    | '/dashboard'
    | '/empresas'
    | '/feature-flags'
    | '/grupos-empresariais'
    | '/motoristas'
    | '/painel'
    | '/parametros'
    | '/perfil'
    | '/recalcular-eventos'
    | '/relatorios'
    | '/teste-viagens-xlsx'
    | '/usuarios'
    | '/veiculo-categorias'
    | '/veiculo-tipos'
    | '/veiculos'
    | '/viagens'
    | '/viagens/$id'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/app-docs'
    | '/_auth/bases-operacionais'
    | '/_auth/dashboard'
    | '/_auth/empresas'
    | '/_auth/feature-flags'
    | '/_auth/grupos-empresariais'
    | '/_auth/motoristas'
    | '/_auth/painel'
    | '/_auth/parametros'
    | '/_auth/perfil'
    | '/_auth/recalcular-eventos'
    | '/_auth/relatorios'
    | '/_auth/teste-viagens-xlsx'
    | '/_auth/usuarios'
    | '/_auth/veiculo-categorias'
    | '/_auth/veiculo-tipos'
    | '/_auth/veiculos'
    | '/_auth/viagens'
    | '/_auth/viagens/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AppDocsRoute: typeof AppDocsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/app-docs': {
      id: '/app-docs'
      path: '/app-docs'
      fullPath: '/app-docs'
      preLoaderRoute: typeof AppDocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/viagens': {
      id: '/_auth/viagens'
      path: '/viagens'
      fullPath: '/viagens'
      preLoaderRoute: typeof AuthViagensRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/veiculos': {
      id: '/_auth/veiculos'
      path: '/veiculos'
      fullPath: '/veiculos'
      preLoaderRoute: typeof AuthVeiculosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/veiculo-tipos': {
      id: '/_auth/veiculo-tipos'
      path: '/veiculo-tipos'
      fullPath: '/veiculo-tipos'
      preLoaderRoute: typeof AuthVeiculoTiposRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/veiculo-categorias': {
      id: '/_auth/veiculo-categorias'
      path: '/veiculo-categorias'
      fullPath: '/veiculo-categorias'
      preLoaderRoute: typeof AuthVeiculoCategoriasRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/usuarios': {
      id: '/_auth/usuarios'
      path: '/usuarios'
      fullPath: '/usuarios'
      preLoaderRoute: typeof AuthUsuariosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/teste-viagens-xlsx': {
      id: '/_auth/teste-viagens-xlsx'
      path: '/teste-viagens-xlsx'
      fullPath: '/teste-viagens-xlsx'
      preLoaderRoute: typeof AuthTesteViagensXlsxRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/relatorios': {
      id: '/_auth/relatorios'
      path: '/relatorios'
      fullPath: '/relatorios'
      preLoaderRoute: typeof AuthRelatoriosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recalcular-eventos': {
      id: '/_auth/recalcular-eventos'
      path: '/recalcular-eventos'
      fullPath: '/recalcular-eventos'
      preLoaderRoute: typeof AuthRecalcularEventosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/perfil': {
      id: '/_auth/perfil'
      path: '/perfil'
      fullPath: '/perfil'
      preLoaderRoute: typeof AuthPerfilRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/parametros': {
      id: '/_auth/parametros'
      path: '/parametros'
      fullPath: '/parametros'
      preLoaderRoute: typeof AuthParametrosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/painel': {
      id: '/_auth/painel'
      path: '/painel'
      fullPath: '/painel'
      preLoaderRoute: typeof AuthPainelRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/motoristas': {
      id: '/_auth/motoristas'
      path: '/motoristas'
      fullPath: '/motoristas'
      preLoaderRoute: typeof AuthMotoristasRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/grupos-empresariais': {
      id: '/_auth/grupos-empresariais'
      path: '/grupos-empresariais'
      fullPath: '/grupos-empresariais'
      preLoaderRoute: typeof AuthGruposEmpresariaisRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feature-flags': {
      id: '/_auth/feature-flags'
      path: '/feature-flags'
      fullPath: '/feature-flags'
      preLoaderRoute: typeof AuthFeatureFlagsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/empresas': {
      id: '/_auth/empresas'
      path: '/empresas'
      fullPath: '/empresas'
      preLoaderRoute: typeof AuthEmpresasRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bases-operacionais': {
      id: '/_auth/bases-operacionais'
      path: '/bases-operacionais'
      fullPath: '/bases-operacionais'
      preLoaderRoute: typeof AuthBasesOperacionaisRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/viagens/$id': {
      id: '/_auth/viagens/$id'
      path: '/$id'
      fullPath: '/viagens/$id'
      preLoaderRoute: typeof AuthViagensIdRouteImport
      parentRoute: typeof AuthViagensRoute
    }
  }
}

interface AuthViagensRouteChildren {
  AuthViagensIdRoute: typeof AuthViagensIdRoute
}

const AuthViagensRouteChildren: AuthViagensRouteChildren = {
  AuthViagensIdRoute: AuthViagensIdRoute,
}

const AuthViagensRouteWithChildren = AuthViagensRoute._addFileChildren(
  AuthViagensRouteChildren,
)

interface AuthRouteChildren {
  AuthBasesOperacionaisRoute: typeof AuthBasesOperacionaisRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthEmpresasRoute: typeof AuthEmpresasRoute
  AuthFeatureFlagsRoute: typeof AuthFeatureFlagsRoute
  AuthGruposEmpresariaisRoute: typeof AuthGruposEmpresariaisRoute
  AuthMotoristasRoute: typeof AuthMotoristasRoute
  AuthPainelRoute: typeof AuthPainelRoute
  AuthParametrosRoute: typeof AuthParametrosRoute
  AuthPerfilRoute: typeof AuthPerfilRoute
  AuthRecalcularEventosRoute: typeof AuthRecalcularEventosRoute
  AuthRelatoriosRoute: typeof AuthRelatoriosRoute
  AuthTesteViagensXlsxRoute: typeof AuthTesteViagensXlsxRoute
  AuthUsuariosRoute: typeof AuthUsuariosRoute
  AuthVeiculoCategoriasRoute: typeof AuthVeiculoCategoriasRoute
  AuthVeiculoTiposRoute: typeof AuthVeiculoTiposRoute
  AuthVeiculosRoute: typeof AuthVeiculosRoute
  AuthViagensRoute: typeof AuthViagensRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthBasesOperacionaisRoute: AuthBasesOperacionaisRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthEmpresasRoute: AuthEmpresasRoute,
  AuthFeatureFlagsRoute: AuthFeatureFlagsRoute,
  AuthGruposEmpresariaisRoute: AuthGruposEmpresariaisRoute,
  AuthMotoristasRoute: AuthMotoristasRoute,
  AuthPainelRoute: AuthPainelRoute,
  AuthParametrosRoute: AuthParametrosRoute,
  AuthPerfilRoute: AuthPerfilRoute,
  AuthRecalcularEventosRoute: AuthRecalcularEventosRoute,
  AuthRelatoriosRoute: AuthRelatoriosRoute,
  AuthTesteViagensXlsxRoute: AuthTesteViagensXlsxRoute,
  AuthUsuariosRoute: AuthUsuariosRoute,
  AuthVeiculoCategoriasRoute: AuthVeiculoCategoriasRoute,
  AuthVeiculoTiposRoute: AuthVeiculoTiposRoute,
  AuthVeiculosRoute: AuthVeiculosRoute,
  AuthViagensRoute: AuthViagensRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AppDocsRoute: AppDocsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
